import {
	ConsultProtocolPacmanEnum,
	ConsultProtocolsItem,
} from 'domain/usecases/private/consult-protocols/get-consult-protocols';
import IconNamesType from 'presentation/icons/IconNamesType';
import {translations} from 'presentation/translations-new';
import {isTablet} from 'react-device-detect';
import {ProtocolTypesEnum} from '../../../constants';
import {formatProtocolDate} from './formatProtocolDate';

const {requestDate, endDate, reason} = translations['pt-br'].privateFlow.consultProtocols;
const {descriptionLabel} = translations['pt-br'].commons;

export function extractProtocolInfo(protocol: ConsultProtocolsItem) {
	const isSacOmbudsmanPacman =
		protocol.tipoProtocolo.toUpperCase() === ProtocolTypesEnum.SAC ||
		protocol.tipoProtocolo.toUpperCase() === ProtocolTypesEnum.OMBUDSMAN ||
		protocol.tipoProtocolo.toUpperCase() === ProtocolTypesEnum.FINANCEIRO ||
		protocol.motivo === ConsultProtocolPacmanEnum.MOTIVO_8 ||
		protocol.motivo === ConsultProtocolPacmanEnum.MOTIVO_56;

	const shouldShowReason = protocol.motivoDescricao && isSacOmbudsmanPacman;
	const shouldShowDescription = protocol.observacao && !isSacOmbudsmanPacman;

	const protocolDetailsList = [
		{
			iconName: 'event-filled' as IconNamesType,
			primaryText: protocol.dtEncerramento
				? formatProtocolDate(protocol.dtEncerramento, true)
				: '-',
			secondaryText: endDate,
			secondaryTextColor: 'text.secondary',
			flexDirection: 'column-reverse',
			sx: {width: isTablet ? '100%' : '85%'},
		},
		...(shouldShowReason
			? [
					{
						iconName: 'content-paste-search-filled' as IconNamesType,
						primaryText: String(protocol.motivoDescricao),
						secondaryText: reason,
						secondaryTextColor: 'text.secondary',
						flexDirection: 'column-reverse',
					},
				]
			: []),
	];

	const protocolSummaryList = [
		{
			iconName: 'event-filled' as IconNamesType,
			primaryText: formatProtocolDate(protocol?.dtAtendimento),
			secondaryText: requestDate,
			secondaryTextColor: 'text.secondary',
			flexDirection: 'column-reverse',
			sx: {width: isTablet ? '100%' : '85%'},
		},
	];

	const protocolDescription = [
		{
			iconName: 'notes-filled' as IconNamesType,
			primaryText: String(protocol.observacao),
			secondaryText: descriptionLabel,
			secondaryTextColor: 'text.secondary',
			flexDirection: 'column-reverse',
		},
	];

	return {
		protocolDetailsList,
		protocolSummaryList,
		shouldShowDescription,
		protocolDescription,
	};
}
